import { render, staticRenderFns } from "./sharedResourceAgreementDetail.vue?vue&type=template&id=cd6181a6&scoped=true"
import script from "./sharedResourceAgreementDetail.vue?vue&type=script&lang=js"
export * from "./sharedResourceAgreementDetail.vue?vue&type=script&lang=js"
import style0 from "./sharedResourceAgreementDetail.vue?vue&type=style&index=0&id=cd6181a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6181a6",
  null
  
)

export default component.exports